import { useRouter } from 'next/router';

export const useTabs = (tabs, url) => {
  const router = useRouter();
  const handleChangeTab = (event, newValue) => {
    router.replace({
      pathname: url,
      query: {
        tab: tabs[newValue].key,
      },
    });
  };
  const selectedTabIndex = tabs.findIndex(
    (item) => item.key === router.query?.tab
  );
  return { handleChangeTab, selectedTabIndex };
};

export default useTabs;
